import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { DataSourceProvider } from "@/adapters/DataSourceProvider";
import { AppPermissions } from "@/auth/AppPermissions";
import { PushClickHandler } from "@/components/notifications/PushClickHandler";
import { registerServiceWorker } from "@/lib/pwa/register";
import { SessionProvider } from "@/auth/SessionProvider";
import { router } from "@/routes/router";
import "./index.css";

registerServiceWorker();

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");

createRoot(root).render(
  <StrictMode>
    <DataSourceProvider>
      {/*
        Session before permissions: `AppPermissions` reads the active
        persona out of `useSession()` to pick which role's permissions
        `PermissionProvider` gets.
      */}
      <SessionProvider>
        <AppPermissions>
          <PushClickHandler />
          <RouterProvider router={router} />
        </AppPermissions>
      </SessionProvider>
    </DataSourceProvider>
  </StrictMode>,
);
